module.exports = __webpack_public_path__ + "static/media/watch-icon.21357a28.svg";